import { TOURIST_SOURCE_COMPARATOR_ADD_COMPARATOR, TOURIST_SOURCE_COMPARATOR_REMOVE_COMPARATOR } from './actionTypes'
import { TOURIST_SOURCE_COMPARATOR_SET_REGION, TOURIST_SOURCE_COMPARATOR_SET_DATA_TYPE, TOURIST_SOURCE_COMPARATOR_SET_SOURCE } from './actionTypes'

export function touristSourceAddComparator() { return { type: TOURIST_SOURCE_COMPARATOR_ADD_COMPARATOR }};
export function touristSourceRemoveComparator() { return { type: TOURIST_SOURCE_COMPARATOR_REMOVE_COMPARATOR }};

export function touristSourceSetRegion(comparatorIndex, region) { return { type: TOURIST_SOURCE_COMPARATOR_SET_REGION, comparatorIndex, region }};
export function touristSourceSetDataType(comparatorIndex, dataType) { return { type: TOURIST_SOURCE_COMPARATOR_SET_DATA_TYPE, comparatorIndex, dataType }};
export function touristSourceSetSource(comparatorIndex, source) { return { type: TOURIST_SOURCE_COMPARATOR_SET_SOURCE, comparatorIndex, source }};


// WEBPACK FOOTER //
// ./src/actions/touristSourceComparator.js